/**
 * InviteAccept Component
 * Extracted from App.jsx - Phase 1 Refactoring
 */
import { useState, useEffect } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LinkIcon from "@mui/icons-material/Link";
import { FONT } from "../theme/tokens";
import { api, v } from "../utils/helpers";
import { Btn, Card } from "../components/ui";

const InviteAccept=({token,onDone})=>{
  const[info,setInfo]=useState(null);const[ld,setLd]=useState(true);const[err,setErr]=useState(null);const[ok,setOk]=useState(false);
  useEffect(()=>{api(`/api/invites/${token}`).then(setInfo).catch(e=>setErr(e.message)).finally(()=>setLd(false));},[token]);
  const accept=async()=>{try{await api(`/api/invites/${token}/accept`,{method:"POST"});setOk(true);}catch(e){setErr(e.message);}};
  if(ld)return<div style={{padding:40,textAlign:"center",color:v("text-3")}}>Laden...</div>;
  if(ok)return<div style={{padding:40,textAlign:"center"}}><CheckCircleOutlineIcon sx={{fontSize:48,color:"var(--success)",mb:2}}/><div style={{fontFamily:FONT,fontSize:22,fontWeight:600,color:"var(--success)",marginBottom:8}}>Angenommen!</div><Btn primary onClick={onDone}>Zu meinen Spaces</Btn></div>;
  return<div style={{padding:40,maxWidth:500,margin:"0 auto"}}><Card><div style={{textAlign:"center",marginBottom:16}}><LinkIcon sx={{fontSize:48,color:"var(--accent)"}}/></div><div style={{fontFamily:FONT,fontSize:20,fontWeight:600,color:"var(--text-1)",textAlign:"center",marginBottom:20}}>Einladung von {info?.invitedByName}</div><div style={{fontSize:11,color:v("text-3"),fontFamily:FONT,marginBottom:6}}>SPACE: {info?.spaceName}</div>{info?.instances?.map(i=><div key={i.id} style={{padding:"8px 12px",borderRadius:8,background:v("surface-2"),border:`1px solid ${v("border")}`,marginBottom:4,color:v("text-1"),fontSize:14}}>{i.name}</div>)}<Btn primary onClick={accept} style={{width:"100%",padding:12,marginTop:16}}>Annehmen</Btn></Card></div>;
};



export default InviteAccept;
